import React from 'react'
import { useState } from 'react'
import MyButton from '../../../UI/form/MyButton'
import MyModal from '../../../UI/modal/MyModal'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SuppliersForm from './SuppliersForm';

const SuppliersFormAdd = ({ supplier }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                supplier ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={supplier ? 'Редагувати постачальника' : 'Додати постачальника'}
            disableClickOutside={true}
            content={
                <SuppliersForm
                    supplierBd={supplier}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default SuppliersFormAdd